module.exports = __webpack_public_path__ + "Vector14.svg?98e1d680921c4db4751554431fc7fe4b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Vector14.svg
// module id = 79
// module chunks = 0